import { Button, DialogActions, DialogContent } from '@mui/material';

import ContentDialog from '../Dialog/ContentDialog';
import HTMLContent from '../HTMLContent';
import IconButtonBlock from './IconButtonBlock';
import React from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

export default function AdditionalContentBlockText({ entryTitle, title, content }) {

    const [diaglogState, setDialogState] = React.useState({ open: false });

    const handleClickOpen = () => {
        setDialogState({ open: true });
    };

    return (
        <>
            <IconButtonBlock heading={title} icon={VisibilityOutlinedIcon} onClick={handleClickOpen} />
            <ContentDialog state={diaglogState} setState={setDialogState} title={entryTitle} subTitle={title}>
                <DirectorDialogContent content={content} />
            </ContentDialog>
        </>
    );
}

function DirectorDialogContent({ handleClose, content, }) {
    return (
        <>
            <DialogContent style={{paddingTop: "1rem"}}>
                <HTMLContent>{content}</HTMLContent>
            </DialogContent>
            <DialogActions style={{ padding: ".5rem 1.5rem 1.5rem", justifyContent: "space-between" }}>
                <Button onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </>
    );
}